import moment from "moment";
import {
  concernsEnum,
  detractors,
  overallFeedback,
  promoters,
} from "../constants/constants";
import { getMapping } from "./getMapping";

export const calculateResponseRatio = (npsData, noFeedback) => {
  const feedbackDataCount = npsData?.length ?? 0;
  const noFeedbackDataCount = noFeedback?.length ?? 0;
  const total =
    feedbackDataCount + noFeedbackDataCount > 0
      ? feedbackDataCount + noFeedbackDataCount
      : 1;
  return Math.ceil((feedbackDataCount / total) * 100);
  // setResponseRatio(Math.ceil((feedbackDataCount / total) * 100));
};

export const calculateMonthWiseConsumedMessages = (npsData, noFeedback, subscriptionStartDate) => {
  const startDate = subscriptionStartDate ? subscriptionStartDate : 1;
  const now = new Date();
  const { end, start } = getBillingCycle(now, startDate)

  let messageConsumed = 0;
  const mergedFeedbackNoFeedbackArray = npsData.concat(noFeedback);

  mergedFeedbackNoFeedbackArray.forEach((data) => {
    const createdDate = new Date(data?.created);
    if (createdDate >= start.getTime() && createdDate < end.getTime()) {
      messageConsumed++;
    }
  });
  return messageConsumed;
};

export const calculateBusinessWiseNPS = (npsData) => {
  const updatedBusinessNPSData = npsData.map((item) => ({
    feedback: getMapping(overallFeedback, item.feedback.overall),
    model: item.metadata.model,
    // updatedDate: new Date(item?.metadata?.updated),
    updatedDate: item?.updated,
    invoice_date: new Date(item?.invoiceDate).toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    }),
    DSE: item.metadata.dse,
    // model_category: item?.metadata?.modelCategory,
    customer_name: item.name,
    phone: item.phone,
    concern: getMapping(concernsEnum, item.feedback.concern),
    subconcern: getMapping(concernsEnum, item.feedback?.["sub-concern"]),
    language: item?.feedback?.language ?? "en",
    team_lead: item?.metadata?.teamLead,
    message_status: item?.messageStatus,
    createdDate: item?.created,
  }));
  return updatedBusinessNPSData;
  // setBusinessChartData(updatedBusinessNPSData);
};
export const getNpsScoreForWalkIn = (npsData, noFeedback) => {

  const walkInNPSData = npsData?.filter((item) => {
    const enquirySource = item?.metadata?.enquirySource || item?.metadata?.source || "";
    return enquirySource.toLowerCase().includes("walk");
  });
  const walkInNoFeedback = noFeedback?.filter((item) => {
    const enquirySource = item?.metadata?.enquirySource || item?.metadata?.source || "";
    return enquirySource.toLowerCase().includes("walk");
  });
  const total = walkInNPSData.length;
  const excellentCount = walkInNPSData.filter((item) => {

    return (
      getMapping(overallFeedback, item.feedback?.overall) === "excellent" ||
      getMapping(overallFeedback, item.feedback?.overall) === "very good"
    );
  }).length;
  const poorCount = walkInNPSData.filter((item) => {
    return (
      getMapping(overallFeedback, item.feedback?.overall) === "poor" ||
      getMapping(overallFeedback, item.feedback?.overall) === "zero"
    );
  }).length;

  const percentage = () => {
    return (excellentCount - poorCount) / total;
  };

  const score = total === 0 ? 0 : percentage().toFixed(2) * 100;


  const responseRatio = calculateResponseRatio(walkInNPSData, walkInNoFeedback);

  return { totalData: walkInNPSData.length, npsScore: score, responseRatio };
};

export const calculateNPSScore = (npsData) => {
  const total = npsData.length;
  const excellentCount = npsData.filter((item) => {
    return (
      getMapping(overallFeedback, item.feedback?.overall) === "excellent" ||
      getMapping(overallFeedback, item.feedback?.overall) === "very good"
    );
  }).length;

  const poorCount = npsData.filter((item) => {
    return (
      getMapping(overallFeedback, item.feedback?.overall) === "poor" ||
      getMapping(overallFeedback, item.feedback?.overall) === "zero"
    );
  }).length;

  const percentage = () => {
    return (excellentCount - poorCount) / total;
  };

  return total === 0 ? 0 : percentage().toFixed(2) * 100;
  // setNpsScore(total === 0 ? 0 : percentage().toFixed(2) * 100);
};

export const countLowRatingReason = (npsData) => {
  const filteredData = npsData.filter((d) => d.feedback["concern"]);
  const reasonCount = filteredData.reduce((acc, obj) => {
    let reasonNumber = obj.feedback.concern;
    let reason = getMapping(concernsEnum, reasonNumber);
    if (reason) {
      reason = reason
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
      acc[reason] = (acc[reason] || 0) + 1;
    }
    return acc;
  }, {});

  const resultArray = Object.entries(reasonCount).map(([reason, value]) => ({
    reason,
    value,
  }));
  const top5Concern = [...resultArray]
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);

  return top5Concern;
  // setConcernData(top5Concern);
};

export const countSubConcern = (npsData) => {
  const filteredData = npsData.filter((d) => d.feedback["sub-concern"]);

  const reasonCount = filteredData.reduce((acc, obj) => {
    let subReasonNumber = obj.feedback?.["sub-concern"];
    let reason = getMapping(concernsEnum, subReasonNumber);
    if (reason) {
      reason = reason
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
      acc[reason] = (acc[reason] || 0) + 1;
    }
    return acc;
  }, {});
  const resultArray = Object.entries(reasonCount).map(([reason, value]) => ({
    reason,
    value,
  }));
  const top5SubConcern = [...resultArray]
    .sort((a, b) => b.value - a.value)
    .slice(0, 5);

  return top5SubConcern;
  // setSubConcernData(top5SubConcern);
};

export const getDateCount = (npsDetails) => {
  const { feedback, noFeedback, failed } = npsDetails;
  const createdTimestamps = [...feedback, ...noFeedback, ...failed].map(
    (f) => f["created"]);
  const sorted = createdTimestamps.sort((a, b) => b - a);

  const arr = sorted.map((timestamp) => {
    const date = moment(timestamp).format("Do MMMM YYYY");
    return date;
  });

  const result = Object.entries(
    arr.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {})
  ).map(([key, value]) => ({
    date: key,
    count: value,
  }));

  return result;
};

export const getReferralData = (npsData) => {
  const referralData = npsData.filter(
    (item) => item?.feedback?.referral === "yes"
  );
  const callBacks = referralData.filter(
    (item) => item?.feedback?.["ref-option"] === "call" || item?.feedback?.["ref-option"] === "call-back"
  );
  const contacts = referralData.filter(
    (item) => item?.feedback?.["ref-option"] === "text"
  );

  return { callBacks, contacts };
};

export const getLanguageData = (npsData) => {
  const languageCount = npsData.reduce((acc, item) => {
    const lang = item.language;
    acc[lang] = (acc[lang] || 0) + 1;
    return acc;
  }, {});
  return languageCount;
};

export const calculateMtdNPSScore = (npsData, noFeedback, subscriptionStartDate) => {
  const startDate = subscriptionStartDate ? subscriptionStartDate : 1;
  const now = new Date();    
  const { end, start } = getBillingCycle(now, startDate)

  const monthNPSData = npsData?.filter((item) => {
    const createdDate = item?.created
    return createdDate >= start.getTime() && createdDate < end.getTime()
  });
  const monthNoFeedback = noFeedback?.filter((item) => {
    const createdDate = item?.created
    return createdDate >= start.getTime() && createdDate < end.getTime()
  });
  const total = monthNPSData.length;
  const excellentCount = monthNPSData.filter((item) => {
    return (
      getMapping(overallFeedback, item.feedback?.overall) === "excellent" ||
      getMapping(overallFeedback, item.feedback?.overall) === "very good"
    );
  }).length;

  const poorCount = monthNPSData.filter((item) => {
    return (
      getMapping(overallFeedback, item.feedback?.overall) === "poor" ||
      getMapping(overallFeedback, item.feedback?.overall) === "zero"
    );
  }).length;

  const percentage = () => {
    return (excellentCount - poorCount) / total;
  };

  const score = total === 0 ? 0 : percentage().toFixed(2) * 100;

  const responseRatio = calculateResponseRatio(monthNPSData, monthNoFeedback);

  return { totalData: monthNPSData.length, npsScore: score, responseRatio };
};

export const getPromoterDetractors = (responses) => {
  const modelNPS = {
    promoters: 0,
    detractors: 0,
    passives: 0,
    total: 0,
  };

  for (const response of responses) {
    if (response.feedback) {
      const feedback = response.feedback;
      if (promoters.includes(feedback)) {
        modelNPS.promoters++;
      } else if (detractors.includes(feedback)) {
        modelNPS.detractors++;
      } else {
        modelNPS.passives++;
      }
      modelNPS.total++;
    }
  }
  const result = [
    { name: "Promoter", value: modelNPS.promoters },
    { name: "Passive", value: modelNPS.passives },
    { name: "Detractor", value: modelNPS.detractors },
  ];
  return result;
};

export const getSalesEnquiryMap = (salesFeedback, enquiryFeedback) => {
  const salesUserPhones = salesFeedback.map((f) => f.phone);

  const retailedEnquiry = [];
  const notRetailedEnquiry = [];
  enquiryFeedback.forEach((f) => {
    const phone = f.phone;
    const isPhoneInFeedback = salesUserPhones.includes(phone);
    // convert feedback enum to feedback value
    const feedback = getMapping(overallFeedback, f.feedback.overall);
    if (isPhoneInFeedback) {
      retailedEnquiry.push({ ...f, feedback });
    } else {
      notRetailedEnquiry.push({ ...f, feedback });
    }
  });

  // Retailed enquiries lie in enquiryFeedback
  const retailedEnquiryNps = getPromoterDetractors(retailedEnquiry);

  // Filter out not retailed enquiries from salesFeedback
  const notRetailedEnquiryNps = getPromoterDetractors(notRetailedEnquiry);

  return { retailed: retailedEnquiryNps, notRetailed: notRetailedEnquiryNps };
};

function getBillingCycle(now = new Date(), startDay = 1) {
  const n = new Date(now);

  let start, end;
  if (n.getDate() < startDay) {
    start = new Date(n.getFullYear(), n.getMonth() - 1, startDay);
    end   = new Date(n.getFullYear(), n.getMonth(),     startDay);
  } else {
    start = new Date(n.getFullYear(), n.getMonth(),     startDay);
    end   = new Date(n.getFullYear(), n.getMonth() + 1, startDay);
  }

  start.setHours(0,0,0,0);
  end.setHours(0,0,0,0);

  return { start, end };
}
